import axios from 'config/axios';
import { ussAPIVersion } from 'services/apiVersions';

export const UpsertQR = (data) => {
  return axios({
    method: 'post',
    url: `/api/${ussAPIVersion}/uss/manage/`,
    data,
  });
};